export { getLocalCurrencyStr as formatCurrency } from '@beef/utils';
export var callOnce = function callOnce(cb) {
  var shouldCall = true;
  return function () {
    if (shouldCall) {
      cb.apply(void 0, arguments);
      shouldCall = false;
    }
  };
};